// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as ActiveStorage from "@rails/activestorage"
import "./custom/turbo_stream_actions"
// import "./custom/companion"

ActiveStorage.start()


import "trix"
import "@rails/actiontext"

// Editors whose toolbar omits the attach control (no `rt-attach` on the
// rich-text-field wrapper) must also refuse dropped/pasted files — hiding
// the button alone doesn't stop attachments (TASK-101.5 follow-up).
document.addEventListener("trix-file-accept", (event) => {
  const wrapper = event.target.closest(".rich-text-field")
  if (wrapper && !wrapper.classList.contains("rt-attach")) {
    event.preventDefault()
  }
})
